import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';

export interface MutationResponse {
  errors?: Error[];
  deleteAnnouncement: boolean;
}

export const mutationFn = async (id: string) => {
  const { deleteAnnouncement, errors } =
    await requestWithAuth<MutationResponse>(
      gql`
        mutation DeleteAnnouncement($id: String!) {
          deleteAnnouncement(id: $id)
        }
      `,
      { id }
    );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return deleteAnnouncement;
};
